<template>
	<div>
		<b-modal id="modal-input" scrollable :no-close-on-backdrop=true :title="'Advance Filter'" :no-close-on-esc=true
			v-model="isFilterShow" :dialog-class="''" :ok-title="'Search'" ok-variant="success" :cancel-title="'Clear'"
			@ok="getBillOfProcesss" @hidden="resetModal">
			<b-card>
				<b-row>
					<b-col cols="12" lg="6">
						<app-input-textbox id="fieldset-bill-of-process-number" label-cols-sm="4" label-cols-lg="3"
							label="Bill Of Process Number" label-for="filter-bill-of-process-number" size="sm"
							:model.sync="filter.billOfProcessNumber" />
						<app-input-combobox-autocomplete :options="parts" optionsLabel="partNumber" optionsKey="id"
							label-cols-sm="4" label-cols-lg="3" label="Part Number" id="filter-" size="sm"
							:model.sync="filter.partNumberId" @input="getParts" @focus="getParts" />
					</b-col>
					<b-col cols="12" lg="6">
						<app-input-combobox-autocomplete :options="nextProcesss" optionsLabel="name" optionsKey="id"
							label-cols-sm="4" label-cols-lg="3" label="NextProcess" id="filter-" size="sm"
							:model.sync="filter.nextProcessId" @input="getNextProcesss" @focus="getNextProcesss" />

						<b-button variant="danger" v-if="false" size="sm" class="float-right" @click="resetFilter"><span
								style="font-size: 0.75rem" class="mr-1"><b-icon-x></b-icon-x></span> Clear Filter</b-button>
						<b-button variant="primary" v-if="false" size="sm" class="float-right mr-1"
							@click="getBillOfProcesss"><span style="font-size: 0.75rem"
								class="mr-1"><b-icon-search></b-icon-search></span> Cari</b-button>
					</b-col>
				</b-row>
			</b-card>
			<template #modal-footer="{ ok }">
				<b-button size="sm" class="btn-default-white float-right" @click="resetFilter()">
					Clear
				</b-button>
				<b-overlay :show="isDataLoading" rounded opacity="0.6" spinner-small spinner-variant="primary"
					class="float-right ">
					<b-button size="sm" class="float-right btn-default" @click="ok()">
						Search
					</b-button>
				</b-overlay>
			</template>
		</b-modal>

		<div>
			<b-row class="mb-2 d-sm-none d-md-flex">
				<b-col class="pt-1">
					<span class="function-title">Bill Of Process</span>
				</b-col>
				<b-col>
					<span class="float-right">
						<b-dropdown text="Action" class="m-md-2 btn-action-more" size="sm">
							<b-dropdown-item v-if="(userRole != null ? userRole.allowDownload : false)"
								href="files/billofprocess/BillOfProcess.xlsx"><b-icon-wallet class="mr-1"></b-icon-wallet>
								Download Template</b-dropdown-item>
							<b-dropdown-item v-if="(userRole != null ? userRole.allowUpdate : false)"
								@click="showPopupUploadData"><b-icon-upload class="mr-1"></b-icon-upload> Upload
								Data</b-dropdown-item>
							<!-- <b-dropdown-item v-if="(userRole != null ? userRole.allowPrint : false)"
								@click="printData"><b-icon-printer class="mr-1"></b-icon-printer> Export To
								Pdf</b-dropdown-item> -->
						</b-dropdown>
						<b-overlay v-if="(userRole != null ? userRole.allowCreate : false)" :show="isCreateBusy"
							opacity="0.6" spinner-small spinner-variant="default" class="d-inline">
							<b-button class="btn-create btn-fill-success" @click="createData" size="sm"> <b-icon-plus-square
									class="mr-1"></b-icon-plus-square>Create New</b-button>
						</b-overlay>

					</span>
					<Portal to="app-navbar-bottom">
						<span class="float-right">
							<b-overlay v-if="(userRole != null ? userRole.allowCreate : false)" :show="isCreateBusy"
								opacity="0.6" spinner-small spinner-variant="default" class="d-inline">
								<b-button class="btn-create btn-fill-success" @click="createData" size="sm">
									<b-icon-plus-square class="mr-1"></b-icon-plus-square>Create New</b-button>
							</b-overlay>

						</span>
					</Portal>
				</b-col>
			</b-row>
			<div class="table-corner">
				<div class="table-action-button">
					<b-button class="btn-action d-sm-none d-md-inline" size="sm" @click="downloadData"><b-icon-download
							class="mr-1"></b-icon-download> Download</b-button>

					<b-overlay v-if="isShowDeleteButton" :show="isDeleteBusy" rounded opacity="0.6" spinner-small
						spinner-variant="primary" class="d-inline-block">
						<click-confirm>
							<b-button class="btn-action" @click="deleteMultipleData" size="sm"><b-icon-trash
									class="mr-1"></b-icon-trash> Delete</b-button>
						</click-confirm>
					</b-overlay>

					<b-button v-if="isShowAdvanceFilterButton" class="btn-action" size="sm"
						@click="isFilterShow = true"><b-icon-search class="mr-1"></b-icon-search> {{ 'Advance Filter' |
							countFilter(filter) }} </b-button>
					<span class="d-inline d-md-none">
						<b-button v-if="!isStacked" class="btn-action float-right btn-action-scroll" size="sm"
							@click="isStacked = true"><b-icon-view-stacked></b-icon-view-stacked></b-button>
						<b-button v-else class="btn-action float-right btn-action-scroll" size="sm"
							@click="isStacked = false"><b-icon-table></b-icon-table></b-button>
					</span>
					<span>
						<b-button :disabled="isPullRight" class="btn-action float-right btn-action-scroll" size="sm"
							@click="scrollRight"><b-icon-caret-right-fill></b-icon-caret-right-fill></b-button>
						<b-button :disabled="isPullLeft" class="btn-action float-right btn-action-scroll" size="sm"
							@click="scrollLeft"><b-icon-caret-left-fill></b-icon-caret-left-fill></b-button>
					</span>
				</div>
				<b-table :stacked="isStacked" id="table-list-billofprocess"
					:class="'table-action ' + (isStacked ? '' : 'table-index')" head-variant="head-light" :bordered="true"
					:no-local-sorting="true" :items="billOfProcesss" :fields="fields" :busy="isDataLoading"
					:sort-by.sync="sortBy" :sort-desc.sync="sortDesc" small responsive show-empty
					:tbody-tr-class="rowClass">
					<template #empty>
						<app-no-data-image />
					</template>
					<template #table-busy v-if="billOfProcesss.length <= 0">
						<app-no-data-image :animate="true" />
					</template>
					<template v-slot:head(front-action)>
						<b-button @click="isShowFilter = !isShowFilter" size="sm"
							class="btn-filter float-right"><b-icon-funnel /></b-button>
					</template>
					<template #top-row v-if="isShowFilter">
						<b-th></b-th>
						<b-th></b-th>
						<b-th stacked-heading="Bill Of Process Number" class="table-filter">
							<b-form-input id="input-bill-of-process-number-table" @input="getBillOfProcesssWithoutLoading"
								v-model="filter.billOfProcessNumber" size="sm"></b-form-input>
						</b-th>
						<b-th stacked-heading="Part Number" class="table-filter">
							<v-select append-to-body label="partNumber" :options="parts" :value="filter.partNumberId"
								:reduce="item => item.id" v-model="filter.partNumberId" :filterable="true"
								@input="getBillOfProcesssWithoutLoading" @search="getParts"></v-select>
						</b-th>
						<b-th></b-th>
						<b-th stacked-heading="NextProcess" class="table-filter">
							<v-select append-to-body label="name" :options="nextProcesss" :value="filter.nextProcessId"
								:reduce="item => item.id" v-model="filter.nextProcessId" :filterable="true"
								@input="getBillOfProcesssWithoutLoading" @search="getNextProcesss"></v-select>
						</b-th>
					</template>
					<template v-slot:cell(no)="row">
						{{ ((row.index + 1) + (pageSizeOptions * (currentPage - 1))) }}
					</template>

					<template v-slot:cell(partnumber)="row">
						<a @click="() => ($router.push({ name: 'billofprocessdetail', params: { id: row.item.id } }))"
							class="a-link-detail">
							{{ row.item.partNumber.partNumber != null && row.item.partNumber.partNumber != "" ?
								(typeof row.item.productCode == 'string') ?
									row.item.partNumber.partNumber.slice(0, 30) + (row.item.partNumber.partNumber.length > 30 ?
										"..." : "") : row.item.partNumber.partNumber : "" }}
						</a>
					</template>

					<!-- <template v-slot:cell(billOfProcessPartType)="row">
				{{ row.item.billOfProcessPartType != null ? row.item.billOfProcessPartType.code : "" }}
			</template> -->
					<template v-slot:cell(partName)="row">
						{{ row.item.partNumber != null ? row.item.partNumber.partName : "" }}
					</template>
					<template v-slot:cell(nextProcess)="row">
						{{ row.item.nextProcess != null ? row.item.nextProcess.name : "" }}
					</template>

					<template v-slot:cell(front-action)="row">
						<div class="d-flex justify-content-center ml-2">
							<b-form-checkbox :id="'input-is-checked-' + (row.index + 1)"
								@change="toggleSelect(Number(row.item.id))"
								:checked="checkAllData.includes(Number(row.item.id))"></b-form-checkbox>
						</div>
					</template>
					<template v-slot:cell(buttonAction)="row">
						<b-button size="sm" @click="toggleIsActive(row.item.id)" :variant="row.item.isActive ? 'outline-danger' : 'outline-success'">
							{{ row.item.isActive ? "Deactivate" : "Activate" }}
						</b-button>
					</template>
					<template v-slot:cell(actions)="row">
						<span>
							<b-button size="sm" @click="row.toggleDetails" class="mr-2 btn-sm btn-transparent border-0">
								<b-icon-chevron-down v-if="!row.detailsShowing"></b-icon-chevron-down>
								<b-icon-chevron-up v-else></b-icon-chevron-up>
							</b-button>
						</span>
					</template>
					<template #row-details="row">
						<b-card>
							<app-input-combobox optionsLabel="partNumber" label-cols-sm="12" :model="row.item.partNumberId"
								label="Part Number"
								:selected="row.item.partNumber != null ? row.item.partNumber.partNumber : ''"
								:isEditable="false" :isUpdatable="true" />
							<app-label label-cols-lg="12" size="sm" label="Part Name"
								:model="(model.partNumber != null) ? model.partNumber.partName : null" />
							<app-input-combobox optionsLabel="name" label-cols-sm="12" :model="row.item.nextProcessId"
								label="NextProcess"
								:selected="row.item.nextProcess != null ? row.item.nextProcess.name : ''"
								:isEditable="false" :isUpdatable="true" />

						</b-card>
					</template>
				</b-table>
			</div>
			<b-row>
				<b-col cols="12" class="paging-container">
					<div>
						<b-row>
							<b-col cols="12">
								<b-pagination class="btn-paging paging-page-size" v-model="currentPage"
									:total-rows="(billOfProcesssPaging != null ? billOfProcesssPaging.dataCount : 0)"
									:per-page="(billOfProcesssPaging != null ? billOfProcesssPaging.pageSize : 0)"
									aria-controls="my-table">
									<template #first-text>
										<b-icon-chevron-left />
									</template>
									<template #prev-text>
										Prev
									</template>
									<template #next-text>
										Next
									</template>
									<template #last-text>
										<b-icon-chevron-right />
									</template>
								</b-pagination>
								<span class="paging-page-size">
									<b-form-select v-if="false" v-model="pageSizeOptions" size="sm" class="float-right"
										:options="pagingOptions"></b-form-select>
									<b-dropdown :text="pageSizeOptions + ' per page'" class="m-md-2 btn-paging-size"
										size="sm">
										<b-dropdown-item v-for="item in pagingOptions" :key="item.value"
											@click="pageSizeOptions = item.value">
											{{ item.text }}
										</b-dropdown-item>
									</b-dropdown>
								</span>
							</b-col>
						</b-row>
					</div>
				</b-col>
			</b-row>
		</div>
		<Upload :openPopup="showPopupUpload" @resetMethod="resetModalUpload" @uploadButtonMethod="uploadData" />
		<PopupDownload :openPopup="showPopupDownload" :processId="processId" @resetModalMethod="resetModal"
			label="Popup Download" :contentLabel="popupDownloadLabel" />
		<PopupPDF :openPopup="isShowPopupPDF" :pdfUrl="pdfUrl" @resetModalMethod="resetModal" label="Popup PDF" />
		<PopupDataEditNotification entityName="approvalconfiguration" :dataId="currentDataId" @resetModalMethod="resetModal"
			label="Data Recovery" />
		<RouterView />
	</div>
</template>
<style lang="scss" scoped>
@import '../../assets/scss/index-page.scss';

::v-deep #table-list-billofprocess.b-table.b-table-stacked>tbody>tr>td.th-front-action::before {
	background-image: url(/img/box-checklist.png);
	background-size: 40px 40px;
	display: block;
	width: 40px;
	height: 40px;
	content: "";
	margin-bottom: 10px;
}

::v-deep #table-list-billofprocess.b-table.b-table-stacked>tbody>tr>td.th-front-action>div {
	display: flex;
}
</style>
<script>
import BillOfProcess from '@/models/BillOfProcess/BillOfProcess';
import BillOfProcessList from '@/models/BillOfProcess/BillOfProcessList';
import BillOfProcessFilter from '@/filters/BillOfProcess/BillOfProcessFilter';
import RoleDetail from '@/models/Core/RoleDetail';

import AppLabel from '@/components/AppLabel';
import AppInputRadio from '@/components/AppInputRadio';
import BillOfProcessPartTypeFilter from '@/filters/BillOfProcessPartType/BillOfProcessPartTypeFilter';
import BillOfProcessPartType from '@/models/BillOfProcessPartType/BillOfProcessPartType';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import AppInputCombobox from '@/components/AppInputCombobox';
import AppInputTextbox from '@/components/AppInputTextbox';
import PartFilter from '@/filters/Part/PartFilter';
import Part from '@/models/Part/Part';
import NextProcessFilter from '@/filters/NextProcess/NextProcessFilter';
import NextProcess from '@/models/NextProcess/NextProcess';
import MachineFilter from '@/filters/Machine/MachineFilter';
import Machine from '@/models/Machine/Machine';
import SubprocessFilter from '@/filters/Subprocess/SubprocessFilter';
import Subprocess from '@/models/Subprocess/Subprocess';
import PopupDownload from '@/components/PopupDownload';
import PopupPDF from '@/components/PopupPDF';
import PopupDataEditNotification from '@/components/PopupDataEditNotification';
import Upload from './Upload';

export default {
	components: {
		BillOfProcess,
		BillOfProcessList,
		BillOfProcessFilter,
		AppLabel,
		AppInputRadio,
		AppInputTextbox,
		AppInputComboboxAutocomplete,
		AppInputCombobox,
		PopupDownload,
		PopupPDF,
		Upload,
		PopupDataEditNotification,
	},
	data() {
		return {
			selectAll: false,
			sortBy: '',
			sortDesc: '',
			pagingOptions: [
				{ value: '10', text: '10', selected: true },
				{ value: '25', text: '25' },
				{ value: '50', text: '50' },
				{ value: '100', text: '100' },
			],
			perPage: 10,
			currentPage: 1,
			totalData: 0,
			fields: [
				{ "front-action": { "class": "th-front-action", "label": "" } },
				//{ "buttonAction": {"class": "th-front-action", "label": ""}},
				{ "no": { "class": "th-number d-stack-none" } },
				{ "billOfProcessNumber": {}, "class": "th-bill-of-process-number first-child", "label": "Bill Of Process Number", key: 'billOfProcessNumber', sortable: true },
				// {"billOfProcessPartType": {}, "class" : "th-bill-of-process-part-type", "label" : "Bill Of Process Part Type", key: 'billOfProcessPartType', sortable: true}, 
				{ "partNumber": {}, "class": "th-part-number last-child", "label": "Part Number", key: 'partNumber', sortable: true },
				{ "partName": {}, "class": "th-part-name d-stack-none", "label": "Part Name", key: 'partName', sortable: true },
				{ "nextProcess": {}, "class": "th-next-process d-stack-none", "label": "NextProcess", key: 'nextProcess', sortable: true },
			],
			yesNoCombo: [
				{ id: 'TRUE', name: 'True', selected: true },
				{ id: 'FALSE', name: 'False' },
			],
			busy: false,
			isDataLoading: false,
			isDownloadDataBusy: false,
			isMultiplePrintBusy: false,
			showPopupUpload: false,
			showPopupDownload: false,
			isShowPopupPDF: false,
			pdfUrl: "",
			selected: '',
			pageSizeOptions: 10,
			pageIndex: 0,
			sortingBy: Array(),
			filter: null,
			processId: "",
			popupDownloadLabel: "",
			hasLoadedData: false,
			showFilter: false,
			isShowFilter: false,
			isCreateBusy: false,
			btnEditData: [],
			currentDataId: null,
			selectedModel: null,
			billOfProcesss: [],
			billOfProcesssPaging: {},
			parts: [],
			nextProcesss: [],
			billOfProcessDetails: [],

			isApprovalBusy: false,
			isFilterShow: false,
			isDeleteBusy: false,
			isPullRight: false,
			isPullLeft: true,
			isStacked: false,
			isScannerMode: false,
		}
	}, methods: {
		toggleIsActive: async function(id) {
			this.isDataLoading = true;
			try {
				const response = await this.$http.post(`BillOfProcess/toggleIsActive/${id}`);
				if(response) {
					await this.getBillOfProcesss();
					this.isDataLoading = false;
				}
			} catch(error) {
				this.$store.dispatch('addErrorMessageGlobal', error);
				throw error;
			} finally {
				this.isDataLoading = false;
			}
		},
		getBillOfProcesss: async function () {
			this.isDataLoading = true;
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}

			BillOfProcess.getList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
				.then(result => {
					if (result != null) {
						this.billOfProcesss = result.data
						this.billOfProcesssPaging = result
					}
					this.isDataLoading = false;
				})
				.catch(error => {
					this.isDataLoading = false;
				});
		},
		getBillOfProcesssWithoutLoading: async function () {
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}

			BillOfProcess.getList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
				.then(result => {
					if (result != null) {
						this.billOfProcesss = result.data
						this.billOfProcesssPaging = result
					}
				})
				.catch(error => { });
		},
		getBillOfProcessPartTypes: async function (input) {
			let filter = new BillOfProcessPartTypeFilter();
			if (input != undefined) {
				filter.code = input;
			}
			BillOfProcessPartType.getList(this, filter, null, 0, 10)
				.then(result => {
					if (result != null) {
						this.billOfProcessPartTypes = result.data
					}
				})
				.catch(error => { });
		},
		getParts: async function (input) {
			let filter = new PartFilter();
			if (input != undefined) {
				filter.partNumber = input;
			}
			if(input == '' && this.filter.partNumberId != null)
			{
				filter.id = this.filter.partNumberId;
			}
			Part.getList(this, filter, null, 0, 10)
				.then(result => {
					if (result != null) {
						this.parts = result.data
					}
				})
				.catch(error => { });
		},
		getNextProcesss: async function (input) {
			let filter = new NextProcessFilter();
			if (input != undefined) {
				filter.name = input;
			}
			
			if(input == '' && this.filter.nextProcessId != null)
			{
				filter.id = this.filter.nextProcessId;
			}
			NextProcess.getList(this, filter, null, 0, 10)
				.then(result => {
					if (result != null) {
						this.nextProcesss = result.data
					}
				})
				.catch(error => { });
		},

		resetFilter() {
			this.filter = new BillOfProcessFilter();
			this.getBillOfProcesss();
			this.isFilterShow = false;
		},
		showPopupUploadData() {
			this.showPopupUpload = true;
		},
		uploadData(modalEvent) {
			this.showPopupUpload = false;
		},
		resetModal() {
			this.showPopupUpload = false;
			this.showPopupDownload = false;
			this.isShowPopupPDF = false;
			this.isFilterShow = false;
		},
		resetModalUpload() {
			this.showPopupUpload = false;
			this.getBillOfProcesss();
		},
		toggleSelect(id) {
			if (this.checkAllData.includes(id)) {
				this.$store.dispatch("removeCheckData", id);
			} else {
				this.$store.dispatch("addCheckData", id);
			}
		},
		showPopupPrint(id) {
			this.showPopupDownload = true;
			this.popupDownloadLabel = "Mempersiapkan data untuk di cetak";
			this.processId = id;
		},
		showPopupDownloadData(id) {
			this.showPopupDownload = true;
			this.popupDownloadLabel = "Mempersiapkan data untuk di unduh";
			this.processId = id;
		},
		showPopupPDF(url) {
			this.isShowPopupPDF = true;
			this.pdfUrl = url;
		},
		printData() {
			let data = this.$store.state.dataIds;
			if (data.length > 0) {
				this.isMultiplePrintBusy = true;
				BillOfProcess.multiPagePrint(this).then(result => {
					if (result) {
						this.showPopupPrint(result.id);
					}
					this.isMultiplePrintBusy = false;
				}).catch(error => { this.isMultiplePrintBusy = false; });
			}
		},
		printSingleData(id) {
			BillOfProcess.singleDataPagePrint(this, id).then(result => {
				if (result) {
					this.showPopupPDF(result.download);
				}
			});
		},
		downloadData() {
			this.isDownloadDataBusy = true;
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}

			BillOfProcess.downloadData(this, this.filter, this.sortingBy)
				.then(result => {
					if (result) {
						this.showPopupDownloadData(result.id);
					}
					this.isDownloadDataBusy = false;
				})
				.catch(error => {
					this.isDownloadDataBusy = false;
				})
		},
		createData() {
			this.isCreateBusy = true;
			BillOfProcess.createData(this).then(result => {
				if (result != null) {
					if (result.id != null && result.id != "") {
						let createRoute = 'billofprocessedit';
						if (this.isScannerMode) {
							createRoute = 'billofprocessscan';
						}

						this.$router.push({ name: createRoute, params: { id: result.id } });
					}
				}
				this.isCreateBusy = false;
			}).catch(error => {
				this.isCreateBusy = false;
			})
		},
		editData(index, id) {
			this.btnEditData[index] = true;
			this.dataId = id;
			BillOfProcess.editData(this, id).then(result => {
				if (result != null) {
					if (result.id != null && result.id != "") {
						this.$router.push({ name: 'billofprocessedit', params: { id: result.id } });
					}
				}
				this.btnEditData[index] = false;
			}).catch(error => { this.btnEditData[index] = false; })
		},

		deleteData(id) {
			BillOfProcess.deleteData(this, id).then(result => {
				if (result) {
					this.getBillOfProcesss();
				}
			})
		},
		deleteMultipleData() {
			let data = this.$store.state.dataIds;
			if (data.length > 0) {
				this.isDeleteBusy = true;
				BillOfProcess.deleteMultipleData(this).then(result => {
					this.getBillOfProcesss();
					this.isDeleteBusy = false;
				}).catch(error => { this.isDeleteBusy = false; });
			}
		},
		onResize() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 576) {
				this.isStacked = true;
			} else {
				this.isStacked = false;
			}
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768) {
				this.isShowFilter = true;
			} else {
				this.isShowFilter = this.showFilter;
			}
		},


		scrollRight() {
			var tableBillOfProcessParent = document.getElementById('table-list-billofprocess').parentNode;
			tableBillOfProcessParent.scrollLeft += 250;
			this.isPullLeft = false;
			this.isPullRight = false;
			if ((tableBillOfProcessParent.scrollWidth - tableBillOfProcessParent.offsetWidth) == Math.ceil(tableBillOfProcessParent.scrollLeft)) {
				this.isPullRight = true;
			}
		},
		scrollLeft() {
			var tableBillOfProcessParent = document.getElementById('table-list-billofprocess').parentNode;
			tableBillOfProcessParent.scrollLeft -= 250;
			this.isPullRight = false;
			this.isPullLeft = false;
			if (tableBillOfProcessParent.scrollLeft <= 0) {
				this.isPullLeft = true;
			}
		},
		rowClass(item, type) {
			if (!item || type !== 'row') return
			if (this.checkAllData.includes(Number(item.id))) return 'item-active';
		}
	},
	beforeMount() {
		this.$store.dispatch("removeCheckAllData");
		this.filter = new BillOfProcessFilter();
		 this.getBillOfProcessPartTypes()
		 this.getParts()
		 this.getNextProcesss()
	},
	mounted() {
		let breadcrumb = [
			"Master Data",
			"Bill Of Process"
		];
		this.$store.dispatch('setBreadCrumb', breadcrumb);
		this.onResize();
		this.$nextTick(() => {
			this.getBillOfProcesss();
			window.addEventListener('resize', this.onResize);
		});
	}, watch: {
		sortBy: {
			handler: function () {
				this.getBillOfProcesss();
			}
		},
		sortDesc: {
			handler: function () {
				this.getBillOfProcesss();
			}
		},
		currentPage: {
			handler: function () {
				this.getBillOfProcesss();
			}
		},
		pageSizeOptions: {
			handler: function () {
				this.getBillOfProcesss();
			}
		},
		selectAll(newValue) {
			if (newValue) {
				BillOfProcess.checkAllData(this, this.filter, this.sortingBy);
			} else {
				this.$store.dispatch("removeCheckAllData");
			}
		},
		'$route'(to, from) {
			if (to != null) {
				if (to.name == "billofprocessindex") {
					this.getBillOfProcesssWithoutLoading();
				}
			}
		},
	},
	computed: {
		checkAllData() {
			return this.$store.state.dataIds;
		},
		userRole() {
			return RoleDetail.query().where("functionInfoId", "bill_of_process").first();
		},
		isShowDeleteButton: function () {
			let userRoleAllowDelete = true;
			if (this.userRole != null) {
				userRoleAllowDelete = this.userRole.allowDelete;
			}

			if (window.innerWidth <= 576) {
				if (userRoleAllowDelete) {
					if (this.checkAllData.length > 0) return true;
				}
				return false;
			}

			return userRoleAllowDelete;
		},
		isShowAdvanceFilterButton: function () {
			if (window.innerWidth <= 576) {
				if (this.checkAllData.length <= 0) return true;
				return false;
			}
			return true;
		}
	}, beforeDestroy() {
		this.$store.dispatch("removeCheckAllData");
	},
}
</script>
